import React from "react";

const PrivacyPolicyDisplay = ({ privacyPolicy }) => {


  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <div
        className="prose prose-slate max-w-full"
        dangerouslySetInnerHTML={{ __html: privacyPolicy?.content }}
      />
    </div>
  );
};

export default PrivacyPolicyDisplay;
